export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "primaryColor",
          name: t('designmenu_general_features_form_base_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t("designmenu_general_features_form_base_color_tooltip"),
          size: "small"
        },
        {
          id: "fontFaceName",
          name: t('designmenu_general_features_form_tipography_name'),
          type: "text",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t("designmenu_general_features_form_tipography_name_tooltip"),
          size: "small"
        },
        {
          id: "fontFaceFile",
          name: t('designmenu_general_features_form_tipography_url'),
          type: "text",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t("designmenu_general_features_form_tipography_url_tooltip"),
          size: "small"
        },
        {
          id: "googleFontName",
          name: t('designmenu_general_features_form_tipography_google'),
          type: "select",
          containerOptions: "googleFonts",
          required: false,
          defaultValue: "",
          size: "small"
        },
        {
          id: "textColorBody",
          name: t('designmenu_general_features_form_tipography_color'),
          type: "color",
          required: true,
          defaultValue: "#000000",
          tooltip: t("designmenu_general_features_form_tipography_color_tooltip"),
          size: "small"
        },
        {
          id: "backgroungImageBody",
          name: t('designmenu_general_features_form_background_image'),
          type: "image",
          required: true,
          isImage: true,
          defaultValue: "",
          tooltip: t("designmenu_general_features_form_background_image_tooltip"),
          size: "small"
        }
      ]
    }
  ]
}